import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

const CELL_PADDING_X = 8;
const TBODY_MARGIN_RIGHT = 1;

const StyledDiv = styled.div`
  position: sticky;
  top: 0;
  left: 8px;
  width: calc(var(--table-wrapper-width) - ${CELL_PADDING_X * 2}px - ${TBODY_MARGIN_RIGHT}px);
`;

type ISubComponentBodyCellProps = PropsWithChildren;

export const SubComponentBodyCell: React.FC<ISubComponentBodyCellProps> = ({ children }) => {
  return (
    <td>
      <StyledDiv>{children}</StyledDiv>
    </td>
  );
};
